import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseComponent } from '@wms/app/components';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { VariableCrudManagerService, BaseVariableService, VariablesTemplateComponent, WmsNavigationVariableService } from '@wms/variables';

@Component({
  standalone: true,
  selector: 'wms-navigation-action-creation',
  templateUrl: './navigation-action-creation.component.html',
  styleUrls: ['./navigation-action-creation.component.less'],
  imports: [VariablesTemplateComponent, CommonModule, TooltipModule]
})
export class NavigationActionCreationComponent extends BaseComponent implements OnInit {
  @Input() selectedVarService: any;

  constructor(public varManagerService: VariableCrudManagerService, public baseVariableService: BaseVariableService,public navigationVarService: WmsNavigationVariableService) { 
    super();
  }

  ngOnInit(): void {
  }

  handleModelChange(changeObj: any) {
    this.baseVariableService.selectedVariable.propertyObj[changeObj.propertyName].modelObj[this.baseVariableService.selectedVariable.propertyObj[changeObj.propertyName].modelKey] = changeObj.$event;  
    this.selectedVarService.__onPropertyChange(changeObj.propertyName, changeObj.$event);
  }

  override ngOnDestroy(): void {
    //[WMS-24554]: clearing the pages info to fetch the updated data as widgets can be modified.
    this.navigationVarService.loadedPages = {};
  }

}
